/**
 * @file
 * Old AMD key: `ac/jira/platform`
 */

/**
 * Returns whether the addon is being shown within a native app on iOS, Android or Mac.
 * @memberof module:Jira
 * @method isNativeApp
 * @param {Function} callback - the callback that handles the response
 */
export const isNativeApp = (callback: (isNative: boolean) => void) => {
	const userAgent = globalThis.navigator?.userAgent;
	let result = false;

	const iOS = /iPhone|iPod|iPad/i.test(userAgent);
	const containsSafari = /Safari/i.test(userAgent);
	const android = /Android/i.test(userAgent);
	const hasWvString = /wv/i.test(userAgent);

	if (iOS && !containsSafari) {
		result = true; // displayed in UIWebView
	} else if (android && hasWvString) {
		result = true; // displayed in WebView https://developer.chrome.com/multidevice/user-agent
	}

	callback(result);
};
